import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainSerReqComponent } from './main-ser-req/main-ser-req.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ServDetailsComponent } from './serv-details/serv-details.component';



@NgModule({
  declarations: [MainSerReqComponent , ServDetailsComponent],
  imports: [
    CommonModule,
    MatTabsModule
  ]
})
export class ServiceRequestModule { }
